import styled from 'styled-components';

export const AlertItemSC = styled.article`
  margin-bottom: 16px;
  box-shadow: ${({ theme }) => theme.shadows.low};
  border-radius: 16px;
  padding: 16px 24px;

  time {
    font-weight: 600;
    font-size: 14px;
    color: rgba(24, 30, 52, 0.4);
    margin-right: 16px;
  }

  .ai-sent {
    font-weight: 600;
    font-size: 14px;
    color: rgba(24, 30, 52, 0.6);
  }
`;

type TAlertBadgeSC = {
  method: 'HILBI' | 'SMS' | 'EMAIL';
};
export const AlertBadgeSC = styled.div<TAlertBadgeSC>`
  display: inline-flex;
  align-items: center;
  padding: 0 12px;
  height: 20px;
  margin-bottom: 10px;
  border-radius: 10px;
  color: #fff;
  font-weight: 800;
  font-size: 14px;
  text-transform: capitalize;
  background: ${({ method }) => {
    if (method === 'EMAIL') {
      return '#333D6C;';
    }
    if (method === 'HILBI') {
      return '#6AD5E5;';
    }
    return `#F5BA42;`;
  }};
`;
